import React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '../../lib/utils';

interface RadioOption {
    value: string;
    label: string;
    icon?: React.ReactNode;
}

interface RadioGroupProps {
    options: RadioOption[];
    value: string;
    onValueChange: (value: string) => void;
    label?: string;
    orientation?: 'horizontal' | 'vertical';
    size?: 'sm' | 'md';
    className?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
    options,
    value,
    onValueChange,
    label,
    orientation = 'horizontal',
    size = 'md',
    className,
}) => {
    return (
        <div className={cn('space-y-2', className)}>
            {label && <span className="text-sm font-medium text-surface-600">{label}</span>}
            <RadioGroupPrimitive.Root
                value={value}
                onValueChange={onValueChange}
                className={cn(
                    'flex gap-1',
                    orientation === 'vertical' ? 'flex-col' : 'flex-wrap'
                )}
            >
                {options.map((option) => (
                    <RadioGroupPrimitive.Item
                        key={option.value}
                        value={option.value}
                        className={cn(
                            'flex items-center gap-2 rounded-lg transition-all duration-200 cursor-pointer border-2',
                            size === 'sm' ? 'px-2 py-1 text-xs' : 'px-3 py-2 text-sm',
                            value === option.value
                                ? 'bg-primary-50 border-primary-500 text-primary-700 shadow-sm'
                                : 'bg-white border-surface-200 text-surface-600 hover:border-surface-300 hover:bg-surface-50'
                        )}
                    >
                        {option.icon && <span className="w-4 h-4">{option.icon}</span>}
                        <span className="font-medium">{option.label}</span>
                    </RadioGroupPrimitive.Item>
                ))}
            </RadioGroupPrimitive.Root>
        </div>
    );
};
